/**
 * A2UI Divider Component
 * Horizontal or vertical divider line
 */

import React from 'react';

const A2UIDivider = ({ 
  orientation = 'horizontal',
  thickness = 1,
  color,
  margin = 16,
  style
}) => {
  const isHorizontal = orientation === 'horizontal';
  
  const dividerStyle = {
    backgroundColor: color || 'var(--border-color, #dee2e6)',
    ...(isHorizontal ? {
      height: `${thickness}px`,
      width: '100%',
      marginTop: `${margin}px`,
      marginBottom: `${margin}px`,
    } : {
      width: `${thickness}px`,
      height: '100%',
      marginLeft: `${margin}px`,
      marginRight: `${margin}px`,
      alignSelf: 'stretch',
    }),
    ...style
  };

  return <div className="a2ui-divider" style={dividerStyle} />;
};

export default A2UIDivider;
